import {
    FETCH_REFERRAL_ID,
    EDIT_REFERRAL_ID,
    FETCH_REFERRAL_ID_SUCCESS,
    FETCH_REFERRAL_ID_FAILED,
    FETCH_REFERRAL_LIST_SUCCESS,
    FETCH_REFERRAL_LIST_FAILED,
    FETCH_REFERRAL_LIST_SUCCESS2,
    FETCH_REFERRAL_LIST_SUCCESS3,
    FETCH_SPONSOR,
    USER_SIGN_OUT,
    CLEAR_OLD_REFERRALS,
    CLEAR_REFERRAL_SUB_LEVELS
} from "../store/types"

export const INITIAL_STATE = {
    usedreferral: null,
    listRefer: null,
    listRefer2: null,
    listRefer3: null,
    elsposor: null,
    loading: false,
    error: {
        flag: false,
        msg: null
    }
}

export const usedreferralreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_REFERRAL_ID:
            return {
                ...state,
                loading: true
            };
        case FETCH_REFERRAL_ID_SUCCESS:
            return {
                ...state,
                usedreferral: action.payload,
                loading: false
            };
        case FETCH_REFERRAL_LIST_SUCCESS:
            return {
                ...state,
                listRefer: action.payload,
                loading: false
            };
        case FETCH_REFERRAL_LIST_FAILED:
            return {
                ...state,
                listRefer: action.payload || [],
                loading: false
            };
        case 'FETCH_REFERRAL_LIST2_LOADING':
            return {
                ...state,
                loading: action.payload
            };
        case FETCH_REFERRAL_LIST_SUCCESS2:
            return {
                ...state,
                listRefer2: action.payload,
                loading: false
            };
        case 'FETCH_REFERRAL_LIST3_LOADING':
            return {
                ...state,
                loading: action.payload
            };
        case FETCH_REFERRAL_LIST_SUCCESS3:
            return {
                ...state,
                listRefer3: action.payload,
                loading: false
            };
        case FETCH_SPONSOR:
            return {
                ...state,
                elsposor: action.payload,
                loading: false
            };
        case 'SET_SPONSOR':
            return {
                ...state,
                elsposor: action.payload
            };
        case 'SET_REFERRAL_LEVEL_2':
            return {
                ...state,
                listRefer2: action.payload
            };
        case 'SET_REFERRAL_LEVEL_3':
            return {
                ...state,
                listRefer3: action.payload
            };
        case 'SET_REFERRAL_ID_LEVEL_1':
            return {
                ...state,
                // Aquí puedes agregar lógica específica si es necesario
            };
        case 'SET_REFERRAL_ID_LEVEL_2':
            return {
                ...state,
                // Aquí puedes agregar lógica específica si es necesario
            };
        case FETCH_REFERRAL_ID_FAILED:
            return {
                ...state,
                usedreferral: null,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload
                }
            };
        case EDIT_REFERRAL_ID:
            return state;
        case CLEAR_REFERRAL_SUB_LEVELS:
            return {
                ...state,
                listRefer2: null,
                listRefer3: null
            };
        case USER_SIGN_OUT:
        case CLEAR_OLD_REFERRALS:
            return {
                ...INITIAL_STATE
            };
        default:
            return state;
    }
}